import { render, staticRenderFns } from "./order-detail2.vue?vue&type=template&id=ae4019ec&scoped=true"
import script from "./order-detail2.vue?vue&type=script&lang=js"
export * from "./order-detail2.vue?vue&type=script&lang=js"
import style0 from "./order-detail2.vue?vue&type=style&index=0&id=ae4019ec&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/shop/order-detail.less?vue&type=style&index=1&id=ae4019ec&prod&scoped=true&lang=less&external"
import style2 from "@/assets/h5css/shop/orderInfo.less?vue&type=style&index=2&id=ae4019ec&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4019ec",
  null
  
)

export default component.exports